import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ROUTE_PATH from 'routes/config';
import Layout from 'layout';
import DataProviderModifyPage from './DataProviderModifyPage';
import DataLinkageModifyPage from './DataLinkageModifyPage';
import { TAB_VALUES } from '../DataLinkageManage/constants';
import { useApp } from 'contexts/AppContext';
import { useUI } from 'contexts/UIContext';

const DataLinkageModify = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { modalData, setModalData, setContextLoading } = useUI();
  const { auth } = useApp();
  const { tabValue, item = {} } = location.state || {};
  const { businessRegistrationNumber, memberRoleData } = auth;
  // 대표 여부
  const isRepresentation = memberRoleData?.representativeYn === 'Y';

  //  수정페이지에 url 입력해서 접근시 데이터 연동 페이지로 이동
  if (!location.state) {
    setContextLoading(true);
    setModalData({
      contents:
        '올바른 접근 방식이 아닙니다.\n데이터 연동 관리화면으로 이동합니다.',
      onClickCloseBtn: () => {
        navigate(ROUTE_PATH.mypage.dataLinkageManage);
      },
    });
  }

  return (
    <Layout pageTitle="데이터 연동 정보 수정" isShowBannerPage={false}>
      {tabValue === TAB_VALUES.MALL_INTERLOCK ? (
        <DataLinkageModifyPage
          businessDataProviderMallMappingSeq={
            item.businessDataProviderMallMappingSeq
          }
          businessRegistrationNumber={businessRegistrationNumber}
          isRepresentation={isRepresentation}
          setContextLoading={setContextLoading}
          setModalData={setModalData}
          modalData={modalData}
        />
      ) : (
        <DataProviderModifyPage
          dataProviderSeq={item.dataProviderSeq}
          setContextLoading={setContextLoading}
          setModalData={setModalData}
        />
      )}
    </Layout>
  );
};

export default DataLinkageModify;
